import { render, staticRenderFns } from "./institutionalTraineeStatistics.vue?vue&type=template&id=65d3a614&scoped=true"
import script from "./institutionalTraineeStatistics.vue?vue&type=script&lang=js"
export * from "./institutionalTraineeStatistics.vue?vue&type=script&lang=js"
import style0 from "./institutionalTraineeStatistics.vue?vue&type=style&index=0&id=65d3a614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3a614",
  null
  
)

export default component.exports